import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Button, Menu, MenuItem } from "@mui/material";
import {
  Add,
  Delete as DeleteIcon,
  Done as DoneIcon,
  Edit,
} from "@mui/icons-material";
import EquipmentBulkUpdate from "../../Dashboard/EquipmentBulkOperation/EquipmentBulkUpdate";
import { useLanguageContext } from "../../../Context/LanguageContext";
import access_ControlStore from "../../../Stores/Access_ControlStores";
import Access_ControlConstants from "../../../Constants/Access_ControlConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import {
  useAMGSelectedContext,
  useMainGridSortContext,
} from "../../../Context/GlobalContext";
import { useItemSelectedFilterContext } from "../../../Context/GridEquipListContext";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { toast } from "react-toastify";
import GridColumnServerConfigButton from "../../Dashboard/MuiDataGridPro/GridColumnServerConfigButton";

export default function RightSideButton({
  gridAction,
  rowCount,
  selectedEqList,
  reportCode,
  handleMultipleActive,
  handleGridSettingChange,
  handleBulkOperationSuccess,
  handleOpenEquipmentGrpConf,
}) {
  const selectedAnlageG = useAMGSelectedContext();
  const sortBy = useMainGridSortContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [bulkAnchorEl, setBulkAnchorEl] = useState(null);
  const [bulkUpdatePopOver, setBulkUpdatePopOver] = useState(false);
  const [showGridColumn, setShowGridColumn] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const navigate = useNavigate();

  const handleBulkClick = useCallback((event) => {
    setBulkAnchorEl(event.currentTarget);
  }, []);

  const handleBulkClose = useCallback(() => {
    setBulkAnchorEl(null);
  }, []);

  const handleBulkOperation = useCallback((event, functionName) => {
    setSelectedAction(functionName);
    setBulkUpdatePopOver(true);
  }, []);

  const togglePopOver = useCallback(() => {
    setBulkUpdatePopOver((prev) => !prev);
    setSelectedAction("");
  }, []);

  const handleAddEquipment = useCallback(
    (event) => {
      event.preventDefault();
      const path =
        "/equipmentGrpEqiupment/AddEquipment/" +
        sessionStorage.getItem("eqBez");
      navigate(path);
    },
    [navigate],
  );

  const handleEqListTableRefersh = useCallback(() => {
    togglePopOver();
    handleBulkOperationSuccess();
  }, []);

  useEffect(() => {
    const updateBulkEquipmentSuccess = () => {
      const res = access_ControlStore.getUpdateAnlageAttributeBulkResult();
      if (res) {
        toast.success(localization.attributeisUpdatedSuccessFully);
        handleEqListTableRefersh();
      }
    };

    const updateBulkEquipmentFailure = () => {
      const res = access_ControlStore.getUpdateAnlageAttributeBulkResult();
      togglePopOver();
      setGlobalSpinner(false);
      toast.error(res);
    };

    access_ControlStore.addChangeListener(
      Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
      updateBulkEquipmentSuccess,
    );
    access_ControlStore.addChangeListener(
      Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE,
      updateBulkEquipmentFailure,
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS,
        updateBulkEquipmentSuccess,
      );
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE,
        updateBulkEquipmentFailure,
      );
    };
  }, [handleEqListTableRefersh, localization, setGlobalSpinner]);

  return (
    <>
      <Grid item>
        {selectedEqList && selectedEqList.length > 0 ? (
          <Grid item>
            {reportCode === "EquipList" && (
              <Button
                variant="contained"
                className="gridTableButton gridTableSelButtonStyle"
                style={{ marginLeft: 8 }}
                startIcon={<DeleteIcon />}
                onClick={handleMultipleActive}
              >
                {localization.delete}
              </Button>
            )}
            {reportCode === "OrdersOView" && (
              <Button
                variant="contained"
                className="gridTableButton gridTableSelButtonStyle"
                style={{ marginLeft: 8 }}
                startIcon={<DoneIcon />}
                onClick={handleMultipleActive}
              >
                {localization.activated}
              </Button>
            )}
          </Grid>
        ) : (
          <>
            {gridAction["actionName"]["DataConfiguration"] && (
              <GridColumnServerConfigButton
                reportCode={reportCode}
                label={gridAction["actionName"]["DataConfiguration"]["text"]}
                name={gridAction["actionName"]["DataConfiguration"]["name"]}
                handleGridSettingChange={handleGridSettingChange}
              />
            )}
            {reportCode === "EquipList" &&
              gridAction["actionName"]["EquipmentGroupConfiguration"] && (
                <Button
                  startIcon={<Edit />}
                  variant="contained"
                  className="gridTableButton gridTableButtonStyle"
                  data-toggle="modal"
                  data-target="#newEquipmentGroup"
                  onClick={handleOpenEquipmentGrpConf}
                >
                  {
                    gridAction["actionName"]["EquipmentGroupConfiguration"][
                      "text"
                    ]
                  }
                </Button>
              )}

            {gridAction["actionName"]["AddEquipment"] && (
              <Button
                startIcon={<Add />}
                variant="contained"
                className="gridTableButton gridTableButtonStyle"
                onClick={handleAddEquipment}
              >
                {gridAction["actionName"]["AddEquipment"]["text"]}
              </Button>
            )}
            {gridAction["actionName"]["Bulk"] && (
              <>
                <Button
                  variant="contained"
                  className="gridTableButton gridTableButtonStyle"
                  style={{ marginLeft: 8 }}
                  onClick={handleBulkClick}
                >
                  {localization.bulkTitle}
                </Button>
                <Menu
                  anchorEl={bulkAnchorEl}
                  open={Boolean(bulkAnchorEl)}
                  onClose={handleBulkClose}
                >
                  {gridAction["actionName"]["Bulk"]["option"].map(
                    (optionList, index) => (
                      <MenuItem
                        key={index}
                        style={{ fontSize: "16px" }}
                        onClick={(e) => {
                          handleBulkClose();
                          handleBulkOperation(e, optionList["name"]);
                        }}
                      >
                        {optionList["text"]}
                      </MenuItem>
                    ),
                  )}
                </Menu>
              </>
            )}
          </>
        )}
      </Grid>
      {bulkUpdatePopOver && (
        <EquipmentBulkUpdate
          rowCount={rowCount}
          handleClose={togglePopOver}
          handleEqListTableRefersh={handleEqListTableRefersh}
          bulkUpdatePopOver={bulkUpdatePopOver}
          slectedAction={selectedAction}
        />
      )}
    </>
  );
}
